#import "../fragments/sms-edition-fragment.graphql"

mutation ScheduleSmsEdition($input: EditionScheduleInput!) {
    editionSchedule(input: $input) {
        edition {
            ...SmsEditionFragment
        }
    }
}
